import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "12.783",
      cy: "12",
      r: "2.297",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "12.784",
      cy: "12",
      r: "5.942",
      stroke: "currentColor",
      "stroke-width": ".983"
    }, null, -1)
  ]))]))
}
export default { render: render }